import { TypographyProps } from './type';
import { StyledTypography } from './styled';

const Typography = ({ children, fontSize, ...props }: TypographyProps) => {
  const { variant, weight, color, whitespace, align, style, ...rest } = props;
  return (
    <StyledTypography
      as={variant}
      weight={weight}
      color={color}
      whitespace={whitespace}
      align={align}
      fontSize={fontSize}
      style={{ ...style }}
      {...rest}
    >
      {children}
    </StyledTypography>
  );
};

Typography.defaultProps = {
  variant: 'span',
  weight: 'normal',
};

export default Typography;
